import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-pdf-section-modal-error',
  templateUrl: '././pdf-section-modal-error.component.html',
})
export class PdfSectionModalErrorComponent {
  @Input() errorMessage: string | null = null;
  @Output() dismissed = new EventEmitter<void>();

  onClose(): void {
    this.dismissed.emit();
  }
  
}